/**
 * @desc 审批语言包
 * @author zhaolun
 * @date 2023年10月26日16:38:06
 */
export default {
  审批管理: '审批管理',
  新增: '新增',
  '请选择/输入值': '请选择/输入值',
  请选择规则: '请选择规则',
  审批事件名称: '审批事件名称',
  流程名称: '流程名称',
  流程描述: '流程描述',
  触发对象: '触发对象',
  请选择触发对象: '请选择触发对象',
  触发按钮: '触发按钮',
  审批归属人: '审批归属人',
  请选择审批归属人: '请选择审批归属人',
  触发条件: '触发条件',
  请设置触发条件: '请设置触发条件',
  审批流程名称: '审批流程名称',
  审批描述: '审批描述',
  审批触发的按钮: '审批触发的按钮',
  弃用状态: '弃用状态',
  请输入审批流程名称: '请输入审批流程名称',
  设置审批分支: '设置审批分支',
  '请输入（可填写用途或备注说明）': '请输入（可填写用途或备注说明）',
  分支: '分支',
  触发审批条件: '触发审批条件',
  审批Code: '审批Code',
  请输入审批Code: '请输入审批Code',
  审批模板: '审批模板',
  请选择审批模板: '请选择审批模板',
  关联接口映射规则: '关联接口映射规则',
  请选择关联接口映射规则: '请选择关联接口映射规则',
  映射规则: '映射规则',
  请选择映射规则: '请选择映射规则',
  请设置: '请设置',
  新增审批事件: '新增审批事件',
  编辑审批流程: '编辑审批流程',
  请选择关联对象: '请选择关联对象',
  触发审批的按钮: '触发审批的按钮',
  请选择触发审批的按钮: '请选择触发审批的按钮',
  启用状态: '启用状态',
  添加分支: '添加分支',
  请完善请求参数: '请完善请求参数',
  字段已停用: '字段已停用',
  对象已停用: '对象已停用',
  '发起审批后，飞书侧飞书审批的实际提交人。': '发起审批后，飞书侧飞书审批的实际提交人。',
  '烽火侧发起审批的实际操作人（与审批归属人可能非同一人员）。': '烽火侧发起审批的实际操作人（与审批归属人可能非同一人员）。',
  已停用: '已停用',
  '（）': '（{0}）'
};
